import { useState } from "react";
import { GhostButton } from "src/components/Buttons";
import { ZipIcon, DownloadIcon2 } from "src/assets/icons";
import {
  PackageContainer,
  PackageHeader,
  PackageTitle,
  PackageSubtitle,
  ZipIconContainer,
} from "./DocumentPackage.styles";

export default () => {
  const [loading, setLoading] = useState(false);

  const downloadAllDocuments = async () => {
    setLoading(true);

    try {
      const link = document.createElement("a");
      link.href = "https://docs.porchpass.com/branded/porchpass/all-files.zip";
      link.download = "all-documents.zip";
      link.target = "_blank";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      await new Promise((resolve) => setTimeout(resolve, 1500));
    } finally {
      setLoading(false);
    }
  };
  return (
    <PackageContainer>
      <PackageHeader>
        <div>
          <PackageTitle>Document package</PackageTitle>
          <PackageSubtitle>
            All files in one package • 3.1MB.zip
          </PackageSubtitle>
        </div>
        <ZipIconContainer>
          <ZipIcon />
        </ZipIconContainer>
      </PackageHeader>
      <GhostButton
        onClick={() => {
          void downloadAllDocuments();
        }}
        loading={loading}
      >
        <DownloadIcon2 />
        Download all
      </GhostButton>
    </PackageContainer>
  );
};
